import { castArray } from 'lodash-es'
// import Ditto from '../../ditto/register.trans'

function dealLookupFieldsValue(defs, rowData) {
  if (!rowData[defs.refSlug]) {
    return null
  }

  if (defs.lookupSlug) {
    return castArray(rowData[defs.refSlug]).map(
      (item) => item && item[defs.lookupSlug]
    )
  }
  if (defs.fieldSpec) {
    const data = rowData[defs.refSlug]
    return data && data[defs.fieldSpec]
  }
  return rowData[defs.refSlug]
}

const transformer = function (origin, defs, rowData) {
  console.log('[abcc]', origin, defs)
  return {
    render: 'lookup',
    origin,
    value: dealLookupFieldsValue(defs, rowData),
    defs,
  }
}

export default transformer
